import React from 'react';
import styled from 'styled-components';
import * as Bento from '@prezi/bento';
import { AnalyticsGraphic } from '@prezi/common-components';
import { localI18n } from '../../../../i18n';
const uxCopy = {
  title: localI18n._("Prezi Analytics"),
  body: localI18n._("Track who views your presentation and which parts really pique their interest with Prezi Premium.")
};
const PlaceholderContainer = styled.div.withConfig({
  displayName: "Placeholder__PlaceholderContainer",
  componentId: "sc-16gun7u-0"
})(["text-align:center;"]);
const BodyText = styled(Bento.Body2).withConfig({
  displayName: "Placeholder__BodyText",
  componentId: "sc-16gun7u-1"
})(["width:260px;margin:0 calc((100% - 260px) / 2);"]);
const Placeholder = () => React.createElement(PlaceholderContainer, null, React.createElement(AnalyticsGraphic, {
  height: 200,
  width: 200
}), React.createElement(Bento.Body1Alt, null, uxCopy.title), React.createElement(BodyText, null, uxCopy.body));
export default Placeholder;